module.exports = __webpack_public_path__ + "img/40_74.cb1d6211.png";